const content = {
  component: "PageTypeA",
  cssClass: "page-four",
  meta: {
    title: "التكنولوجيا السحابية تخفّف محنة النحل",
    description:
      "يستخدم الباحثون الذكاء الاصطناعي للحفاظ على حياة النحل وتحقيق التوازن بين الطبيعة والبشر.",
    og: {
      type: "website",
      title: "اعرف كيف تنقذ تكنولوجيا الذكاء الاصطناعي حياة النحل",
      description: `للنحل أهمية بالغة في بقائنا واستمرارنا كبشر، لكنه يموت بسرعة مقلقة. من خلال تحليل البيانات الصوتية الصادرة عن خلايا النحل، عبر الاستماع لحركة أجنحتها وأقدامها، بإمكان تكنولوجيا الذكاء الاصطناعي التنبؤ بموعد هجرتها. ذلك يساعدنا على التدخل إذا حصلت هذه الهجرة في وقت غير ملائم من العام.`,
      image: require("../../assets/images/social/silver-lining-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title: "اعرف كيف تنقذ تكنولوجيا الذكاء الاصطناعي حياة النحل",
      description: `بدون النحل، قد يهلك البشر. ولهذا يستخدم The World Bee Project تكنولوجيا الذكاء الاصطناعي في التنبؤ بسلوكيات النحل ومنعها من الهجرة في الأوقات الخطيرة أثناء العام.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/silver-lining-300x300.jpg")
    }
  },
  title: "<span>التكنولوجيا السحابية تخفّف محنة النحل</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/silver-lining-pre.jpg"),
    loaded: require("../../assets/images/bgs/silver-lining.jpg"),
    mobile: require("../../assets/images/bgs/silver-lining-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [true, "center -10px"]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
        تهدف صبيحة روماني مالك، مؤسِسة ورئيسة The World Bee Project - وهي شركة عالمية ناشئة من فئة المؤسسات الاجتماعية - إلى حماية أعداد النحل من الانخفاض والتناقص. وللشركة عدد من المبادرات التي توظف أحدث التقنيات، حيث استعانت مؤخرًا بقوة التكنولوجيا السحابية وشبكة دولية من خلايا النحل الذكية المراقَبة عن بُعد. وبحسب وصف صبيحة مالك، فإن ذلك يُعدّ "مزيجًا رائعًا بين الطبيعة والتكنولوجيا".
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>"تضيف صبيحة بقولها: "تؤكد البيانات من جميع أنحاء العالم أن نحل العسل هو أهم فصيلة من حشرات تلقيح الأزهار والنباتات في النظم البيئية الطبيعية، ومساهم أساسي في سلامة النظم البيئة الطبيعية."</p>
          <p>من كاليفورنيا حتى ولاية أوتاراكاند في شمال الهند، ستجد مشاريع تربط النحل بالأمن الغذائي، وسُبل المعيشة، والإدماج الاجتماعي. وتحظى جميعها بدعم صبيحة روماني مالك، وذلك لسبب وجيه للغاية من وجهة نظرها.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `تقول صبيحة: "يلقّح النحل النباتات والأزهار. ونحن معتمدون تمامًا عليه في إنتاج الغذاء الذي نأكله. ولكن يمثّل تناقص أعداد النحل تهديدًا خطيرًا للأمن الغذائي في العالم أجمع. ويجب علينا أن نقدم حلولاً مبتكرة لضمان استمراريته لتلقيح المحاصيل الغذائية التي نحتاجها لإطعام أجيال المستقبل."`,
        author: `Sabiha Rumani Malik`,
        position: `المؤسس, The World Bee Project`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>لتحقيق ذلك، أسست "صبيحة" The World Bee Project بهدف طَموح هو إنشاء "علاقة مستدامة بين تلقيح النباتات والأمن الغذائيَ والتنوع البيولوجي وسلامة البشر ورفاهيتهم".</p>
          <p>وكان من الطبيعي أن يكون لشركة The World Bee Project شركاء حول العالم من جامعة "ج. ب. بانت للزراعة والتكنولوجيا"، وهي من أكبر كليات التعليم الزراعي في الهند، والمعروفة أيضًا باسم جامعة "بانتناجار"، مرورًا بمبادرة مَزارع الهيمالايا  ووصولا إلى كلية الزراعة وعلوم الغذاء في جامعة Széchenyi István في المجر. </p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/iot.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>غير أن أهم شراكات The World Bee Project في أوروبا هي مع "كلية الزراعة والسياسات والتنمية" في جامعة ريدينغ، وهي من أكبر عشر كليات للزراعة في العالم. وتهدف المبادرة الأكثر طموحًا وتقدمًا وتأثيرًا إلى التعاون مع صغار المزارعين، أي مالكي الأراضي الصغيرة، لتنفيذ عملية التكثيف البيئي وزيادة أعداد النحل.</p>
          <p>يأمل برنامج The World Bee Project Hive Network أن يتمكّن هذا المشروع والمشاريع الأخرى، من استخلاص معلومات مهمة من شبكة خلايا النحل الذكية المنتشرة في أنحاء العالم. وتجمع الشبكة التي بدأت في سبتمبر 2018 البيانات من المجسات المتصلة بالإنترنت وهي من تصنيع شركة Arnia. وتسفر هذه المجسات التي تقيس ظروف الخلايا مثل الحرارة والرطوبة وإنتاجية العسل عن إنتاج ما مقداره 2 تيرابايت من البيانات يوميًا.</p>
          <p>ويساعد ذلك الباحثين على استخدام البيانات الصوتية الدقيقة التي يتم تسجيلها من الخلايا مثل حركة أجنحة النحل وأقدامها من أجل "الاستماع" للخلايا للتنبؤ بالحالات المختلفة للمستعمرة على مدار العام. على سبيل المثال عندما تستعد المستعمرة للهجرة في ظروف غير ملائمة أثناء العام.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `شراكتنا مع Oracle Cloud تُعد مزيجًا رائعًا بين الطبيعة والتكنولوجيا. ومن شأن هذه الشراكة أن تساهم في تطوير البحوث، وتفعيل جهود العمل على نطاق كبير لم يكن ممكنًا من قبل.`,
        author: `Sabiha Rumani Malik`,
        position: `المؤسس, The World Bee Project`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>تتوفر هذه البيانات بشكل كبير لكل من الباحثين والمؤسسات في جميع أنحاء العالم ممن يهتمون بتلقيح النباتات والأمن الغذائي والتنوّع البيولوجي.</p>
          <p>يقول البروفيسور سايمون بوتس، المؤسس المشارك لمشروع The World Bee Project والخبير العالمي الرائد في مجاله: "من خلال تبادُل هذه البيانات مع نظرائنا، فإننا نضاعف تأثير جهودنا".</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `إن توفير هذا المورد الهائل من البيانات بسهولة لا يقل أهمية عن الجهود المبذولة في جمعها. ولا شك أن ذلك يصبّ في مصلحة كل من الأبحاث الأكاديمية التي تغيّر الممارسات الزراعية، والبرامج التعليمية الملهمة للأطفال.`,
        author: `Professor Simon Potts`,
        position: `المؤسس المشارك, The World Bee Project`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        يتمثّل هدف برنامج The World Bee Project Hive Network في الحفاظ على الممارسات التقليدية المتّبعة في تربية النحل واستمراره، إلى جانب بناء المعرفة وتعزيز الجهود التعاونية والمبادرات العملية. التكنولوجيا السحابية تقوم حاليًا بدور كبير في تخفيف محنة النحل.
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `طوّر أعمالك مع حلول وتكنولوجيا Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: `تقرير "صُنّاع القرار والتكنولوجيا"`,
            url:
              "https://www.oracle.com/sa-ar/area-of-interest/it/leading-technologies-survey.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_AW_HI_CM_SA_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_AW_HI_CM_SA_C33_Q33_RT",
            buttonCopy: "اقرأ التقرير"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
